import PageContainer from 'components/PageContainer/PageContainer';
import RespuestaServidor from './RespuestaServidor';
import { RunningWithErrors } from '@mui/icons-material';
import PasosDeCompra from 'components/public/FichaEspectaculo/PasosDeCompra';
import { hasErrorCompra } from 'utils/storage/compra';

const FailCompra = () => {
  const error = hasErrorCompra();

  return (
    <PageContainer marginBottom={true}>
      <PasosDeCompra paso={3} error />
      <RespuestaServidor
        titulo={error ? '¡Ocurrió un error!' : 'Ocurrió un error en el proceso'}
        texto={
          error
            ? 'A pesar de ello, la compra se realizó correctamente. Comunicate con un administrador para recibir las entradas.'
            : 'Intentá nuevamente la compra o comunicate con un administrador'
        }
        icono={RunningWithErrors}
        textoBoton="Volver"
        colorIcono="error"
        paginaANavegar={-1}
      />
    </PageContainer>
  );
};

export default FailCompra;
